module.exports = __webpack_public_path__ + "img/stories_grey.d2f69465.png";